import { adminUserRoles, AuthenticationOptions, AuthTokenOptions, ProfileModel } from "@tsin-core/store/auth/auth.model";
import { buildUrl } from "./route-utils";
import { environment } from "@tsin-env/environment";

export function hasAdminRole(profiles: ProfileModel[]): boolean {
  return profiles.some(profile => adminUserRoles.includes(profile.role));
}

export function redirectUserToken(service: string, urlPayload: AuthTokenOptions) {
  switch (service) {
    case 'pro':
      // Check if user should go to test environment
      const isTestUser1 = urlPayload.email === 'pro.info@tsin.ca';
      const proBaseUrl = environment.proServiceUrl;

      const proServiceUrl = buildUrl(
        proBaseUrl,
        'account/validate-token',
        {
          type: urlPayload.examType,
          code: urlPayload.code,
          reload: urlPayload.reload,
        });
      window.open(proServiceUrl, '_blank')
      return;
    case 'work-with-us':
    case 'work_with_us':
      const workwithusServiceUrl = buildUrl(
        environment.workwithusServiceUrl,
        'account/validate-token',
        {
          type: urlPayload.examType,
          code: urlPayload.code,
          reload: urlPayload.reload,
        });
      window.open(workwithusServiceUrl, '_blank')
      return;
    case 'finance':
      const financeServiceUrl = buildUrl(
        environment.paymentServiceUrl,
        'account/validate-token',
        {
          type: urlPayload.examType,
          code: urlPayload.code,
          reload: urlPayload.reload,
        });
      window.open(financeServiceUrl, '_blank')
      return;
    case 'learning':
      // Check if user should go to test environment
      const testUsers = ['s.gunishetty+learneradmin@tsin.ca', 's.gunishetty+fac@tsin.ca'];
      const isTestUser =
        !!urlPayload.email && testUsers.includes(urlPayload.email);
      const learningBaseUrl = isTestUser
        ? environment.learningServiceTestUrl
        : environment.learningServiceUrl;

      const learningServiceUrl = buildUrl(
        learningBaseUrl,
        'account/validate-token',
        {
          type: urlPayload.examType,
          code: urlPayload.code,
          reload: urlPayload.reload,
        }
      );
      window.open(learningServiceUrl, '_blank')
      return;
    case 'exam':
    default:
      const examServiceUrl = buildUrl(
        environment.examServiceUrl,
        'account/validate-token', {
        type: urlPayload.examType,
        code: urlPayload.code,
        reload: urlPayload.reload,
      }
      );
      window.open(examServiceUrl, '_blank')
      return;
  };
};
